module.exports = __webpack_public_path__ + "8de897514ccc0cdc717b951eca640b8d.pdf";